export function initialsOf(name: string | null | undefined): string {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
  return parts.slice(0, 2).map((p) => p[0]!.toUpperCase()).join('') || '?'
}

export function firstNameOf(name: string | null | undefined): string {
  return String(name || '').trim().split(/\s+/)[0] || ''
}
